import { render, staticRenderFns } from "./RhFuncionarioRead.vue?vue&type=template&id=1dacc34c&"
import script from "./RhFuncionarioRead.vue?vue&type=script&lang=js&"
export * from "./RhFuncionarioRead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports